import { render } from "./help-dialog-api-keys.vue?vue&type=template&id=aefd12c6"
import script from "./help-dialog-api-keys.vue?vue&type=script&setup=true&lang=js"
export * from "./help-dialog-api-keys.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/integrations/pages/link-marketplace/components/woocommerce/help-dialog-api-keys.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "aefd12c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('aefd12c6', __exports__)) {
    console.log('reload')
    api.reload('aefd12c6', __exports__)
  }
  
  module.hot.accept("./help-dialog-api-keys.vue?vue&type=template&id=aefd12c6", () => {
    console.log('re-render')
    api.rerender('aefd12c6', render)
  })

}


export default __exports__